/// ************ original code ************** commemted 

import { useEffect, useState } from "react";
import styles from "./SuccessMessage3.module.css";
import successtickmark from "../../assets/successtickmark.png";
import auth from "../../Auth/Auth";
// import http from "../../Auth/httpservices";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";

const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
const marketingFrontendUrl = import.meta.env.VITE_MARKETING_FRONTEND_URL;

const sendBundlePurchaseEmail = async () => {
  try {
    // Get cart data from localStorage
    const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
    const totalAmount = localStorage.getItem("totalAmount") || "0";
    const currency = localStorage.getItem("currency") || "SAR";
    
    const response = await axios.post(`${marketingBackendUrl}/maflam/send-bundle-purchase-email`, {
      to: localStorage.getItem("useremailidis"),
      customerName: localStorage.getItem("currentusername") || localStorage.getItem("fullname") || "ضيف",
      bundleName: localStorage.getItem("coursenamearabic"),
      totalAmount: totalAmount,
      currency: currency,
      courses: cartItems.map(item => ({
        name: item.courseNameArabic || item.courseNameEnglish,
        price: item.courseCostEnglish || item.courseCostArabic
      })),
      logoUrl: 'https://maflam.com/home/assets/logo1-DJkTmGfR.png',
      loginLink: `${marketingFrontendUrl}/login`,
      downloadLink: `${marketingFrontendUrl}/transaction`
    });

  } catch (error) {
    console.error('Error sending bundle purchase email:', error);
  }
};

const sendCoursePurchaseEmail = async (courseNames = null) => {
  try {
    // Get cart data from localStorage
    const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
    const totalAmount = localStorage.getItem("totalAmount") || "0";
    const currency = localStorage.getItem("currency") || "SAR";
    
    console.log("=== EMAIL DEBUG ===");
    console.log("Cart items from localStorage:", cartItems);
    console.log("Cart items length:", cartItems.length);
    console.log("Total amount:", totalAmount);
    console.log("Currency:", currency);
    console.log("Course names from backend:", courseNames);
    console.log("=== END EMAIL DEBUG ===");
    
    // Use course names from backend response if available, otherwise fallback to localStorage
    let courseNameArabic, courseNameEnglish;
    
    if (courseNames && courseNames.arabic && courseNames.english) {
      // Use course names from backend response
      courseNameArabic = courseNames.arabic;
      courseNameEnglish = courseNames.english;
    } else {
      // Fallback to localStorage
      courseNameArabic = localStorage.getItem("coursenamearabic");
      courseNameEnglish = localStorage.getItem("coursenameenglish");
      
      // If still not available, use generic fallback
      if (!courseNameArabic || !courseNameEnglish) {
        courseNameArabic = "Course Purchase";
        courseNameEnglish = "Course Purchase";
      }
    }
    
    // Check if this is a cart purchase (multiple courses)
    const isCartPurchase = cartItems.length > 0 || (courseNameArabic && courseNameArabic.includes(','));
    
    const response = await axios.post(`${marketingBackendUrl}/maflam/send-course-purchase-email`, {
      to: localStorage.getItem("useremailidis"),
      customerName: localStorage.getItem("currentusername") || localStorage.getItem("fullname") || "ضيف",
      courseName: courseNameEnglish || courseNameArabic || "Course Purchase",
      courseNameArabic: courseNameArabic || "Course Purchase",
      courseNameEnglish: courseNameEnglish || "Course Purchase",
      totalAmount: totalAmount,
      currency: currency,
      // Include all cart items for multiple course purchases
      cartItems: isCartPurchase ? cartItems.map(item => ({
        courseNameArabic: item.courseNameArabic,
        courseNameEnglish: item.courseNameEnglish,
        courseCostEnglish: item.courseCostEnglish,
        courseCostArabic: item.courseCostArabic
      })) : [],
      isCartPurchase: isCartPurchase,
      logoUrl: 'https://maflam.com/home/assets/logo1-DJkTmGfR.png',
      loginLink: `${marketingFrontendUrl}/login`,
      downloadLink: `${marketingFrontendUrl}/transaction`
    });
    
    console.log("Email sent with course names:", courseNameArabic, courseNameEnglish);
  } catch (error) {
    console.error('Error sending course purchase email:', error);
  }
};

function SuccessMessage3() {
  const [ID, setIddata] = useState("");
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Retrieve the payment ID from localStorage and update state
    const getId = localStorage.getItem("payment_id");
    if (getId) {
      setIddata(getId);
    } else {
      console.error("No payment ID found in localStorage");
      navigate("/home/failuremessage");
    }
  }, [navigate]);

  useEffect(() => {
    if (!ID) return; // Exit if ID is not set

    const validateTransaction = async () => {
      const timeout = (ms) =>
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Request timed out")), ms)
        );

      try {
        const userdetails = auth.getAuthData();
        const token = userdetails?.token;
        const response = await Promise.race([
          axios.get(
            `${marketingBackendUrl}/maflam/retrive-a-payment?paymentId=${ID}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          timeout(30000), // 30-second timeout
        ]);


        if (response.data.data.success == 0) {
         navigate("/home/failuremessage");
        } else {
          // Extract course names from backend response
          const courseNames = response.data.data.courseNames;
          console.log("Course names from backend response:", courseNames);
          
          // For guest users, call handle-email with payment success status to send credential email
          const fullName = localStorage.getItem("fullname");
          const email = localStorage.getItem("useremailidis");
          if (fullName && email) {
            const [firstName, ...rest] = fullName.split(" ");
            const lastName = rest.join(" ");
            try {
              await axios.post(`${marketingBackendUrl}/maflam/handle-email`, {
                emailId: email,
                firstName,
                lastName,
                paymentSuccess: true
              });
              console.log("Credential email sent after payment success");
              
              // Set the currentusername in localStorage for navbar display
              localStorage.setItem("currentusername", fullName);
              
              // Update auth data with the full name
              const authData = auth.getAuthData();
              if (authData) {
                authData.fullName = fullName;
                authData.usernameInEng = fullName;
                auth.login(authData);
              }
              
              // Dispatch custom event to notify navbar of user data update
              window.dispatchEvent(new CustomEvent('userDataUpdated', {
                detail: { username: fullName, courseCount: 1 }
              }));
            } catch (error) {
              console.error("Error sending credential email:", error);
            }
          }
          
          // Call the email functions before navigating
          const courseNameEnglish = localStorage.getItem("coursenameenglish");
 
          if (courseNameEnglish === 'Filmmaking Fundamentals Package') {
            await sendBundlePurchaseEmail();
          } else {
            await sendCoursePurchaseEmail(courseNames);
          }
          
          // Clean up cart data from localStorage after email is sent
          localStorage.removeItem("cartItems");
          localStorage.removeItem("totalAmount");
          localStorage.removeItem("currency");
          
          const couponCode = localStorage.getItem("coupon"); // Retrieve coupon from localStorage
          if (couponCode) {
            await updateCoupon(couponCode);
          }
          localStorage.setItem("courseCount", 1);
   
          navigate("/home/success");
        }
      } catch (error) {
        console.error("Transaction validation error:", error.message || error);
        navigate("/home/failuremessage");
      } finally {
        setLoading(false); // Set loading to false after validation
      }
    };

    validateTransaction();
  }, [ID, navigate]);

  // Update Coupon function that marks the coupon as "Used"
  const updateCoupon = async (couponCode) => {
    const updateData = { couponState: "Used" };

    try {
      const response = await axios.put(
        `${marketingBackendUrl}/maflam/updatecoupon/${couponCode}`,
        updateData
      );
    } catch (error) {
      console.error("Error updating coupon:", error);
    }
  };

  return (
    <div className={styles.maincontainer}>
      {loading && <div className={styles.loader}></div>}
    </div>
  );
}

export default SuccessMessage3;



